import api from './client';

export const getCategories    = ()           => api.get('/categories');
export const createCategory   = (data)       => api.post('/categories', data);
export const updateCategory   = (id, data)   => api.patch(`/categories/${id}`, data);
export const deleteCategory   = (id)         => api.delete(`/categories/${id}`);
export const reorderCategories = (ids)       => api.post('/categories/reorder', { ids });
